import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14 8.3H6.652c-.868 0-1.303 1.05-.69 1.665l3.266 3.21V11.32l-1.67-1.67H14V14H2V7.775h7.376c.868 0 1.304-1.05.69-1.665L6.8 2.9v1.855l1.67 1.67H2V2h12v6.3Z';
const draw24px =
  'M22 12.5H9.754c-1.448 0-2.173 1.75-1.15 2.774l5.443 5.351v-3.092l-2.783-2.783H22V22H2V11.625h12.293c1.448 0 2.173-1.75 1.15-2.774L10 3.5v3.092l2.783 2.783H2V2h20v10.5Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const GCPayIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'GCPay'),
) as IconWithRender;

GCPayIcon.displayName = 'GCPayIcon';
GCPayIcon.propTypes = Icon.propTypes;
GCPayIcon.renderIcon = (props) => <GCPayIcon {...props} />;
export default GCPayIcon;
